import React from 'react'
import "./about.css";
import Info from './info';
import CV from "../../assets/MioNova.pdf";

const About = () => {
  return (
    <section className="about section" id='about'>
      <h2 className="section__title">About Me</h2>
      <span className="section__subtitle">My Introduction</span>

      <div className="about__container container grid">

          <div className="about__data">
            <Info />

             <p className="about__description">
  My journey into tech started with a simple obsession: solving real problems through code. That obsession became a discipline — building web solutions that are reliable, scalable, and genuinely useful. I don't just write code that works; I write code that lasts.
  <br /><br />
  Great software lives at the intersection of clean engineering and strategic thinking. I align every technical decision with user needs and business goals, because a product that's functional but meaningless isn't the goal — impact is. Collaboration, continuous learning, and obsessive attention to detail shape how I work.
  <br /><br />
  Outside of shipping code, I'm exploring emerging tech, contributing to open-source, and staying plugged into the developer community — because growth doesn't stop when the laptop closes.
</p>

              <a download="" href={CV} className="button button__flex">
                Download CV
                <svg className="button__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                     <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M10 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22
                      19.6569 22 17.7712 22 14V13.5629C22 12.6901 22 12.0344 21.9574 11.5001H18L17.9051 11.5001C16.808 11.5002 15.8385 
                      11.5003 15.0569 11.3952C14.2098 11.2813 13.3628 11.0198 12.6716 10.3285C11.9803 9.63726 11.7188 8.79028 11.6049 7.
                      94316C11.4998 7.16164 11.4999 6.19207 11.5 5.09497L11.5092 2.26057C11.5095 2.17813 11.5166 2.09659 11.53 2.01666C11.
                      1214 2 10.6358 2 10.0298 2C6.23869 2 4.34315 2 3.17157 3.17157C2 4.34315 2 6.22876 2 10V14C2 17.7712 2 19.6569 3.17157
                       20.8284C4.34315 22 6.22876 22 10 22Z" fill="var(--container-color )"></path> 
                     <path d="M9.01296 19.0472C8.72446 19.3176 8.27554 19.3176 
                       7.98705 19.0472L5.98705 17.1722C5.68486 16.8889 5.66955 16.4142 5.95285 16.112C6.23615 15.8099 6.71077 15.7945 7.01296 
                       16.0778L7.75 16.7688V13.5C7.75 13.0858 8.08579 12.75 8.5 12.75C8.91422 12.75 9.25 13.0858 9.25 13.5L9.25 16.7688L9.98705
                        16.0778C10.2892 15.7945 10.7639 15.8099 11.0472 16.112C11.3305 16.4142 11.3151 16.8889 11.013 17.1722L9.01296 19.0472Z"
                         fill="var(--container-color)"></path> 
                     <path d="M11.5092 2.2601L11.5 5.0945C11.4999 6.1916 11.4998 7.16117 11.6049 7.94269C11.7188 8.78981
                          11.9803 9.6368 12.6716 10.3281C13.3629 11.0193 14.2098 11.2808 15.057 11.3947C15.8385 11.4998 16.808 11.4997 17.9051 11.4996L21.
                          9574 11.4996C21.9698 11.6552 21.9786 11.821 21.9848 11.9995H22C22 11.732 22 11.5983 21.9901 11.4408C21.9335 10.5463 21.5617 9.52125 
                          21.0315 8.79853C20.9382 8.6713 20.8743 8.59493 20.7467 8.44218C19.9542 7.49359 18.911 6.31193 18 5.49953C17.1892 4.77645 16.0787 3.98536 
                          15.1101 3.3385C14.2781 2.78275 13.862 2.50487 13.2915 2.29834C13.1403 2.24359 12.9408 2.18311 12.7846 2.14466C12.4006 2.05013 12.0268
                           2.01725 11.5 2.00586L11.5092 2.2601Z" fill="var(--container-color)"></path> 
                  </g>
                </svg>
              </a>
          </div>

      </div>
    </section>
  )
}

export default About
